import './layouts.scss';



// WEBPACK FOOTER //
// ./src/assets/layouts/layouts.js